module.exports = __webpack_public_path__ + "img/video.c439462c.png";